'use strict';

frontendApp.factory('ResourceNoteService', ['$rootScope', '$resource', 'ConfigService', 'ResourceWrapperService', 'TokenService', 'HttpService', 'NotificationService', function ($rootScope, $resource, ConfigService, ResourceWrapperService, TokenService, HttpService, NotificationService) {

  var _service = {};

  var RawResourceNote = $resource(ConfigService.getServerBaseUrlForResource() + '/project/:projectId/collection/:collectionId/resource/:resourceId/note/:id',
    {'id': '@id', 'projectId': '@projectId', 'collectionId': '@collectionId', 'resourceId': '@resourceId'},
    {'update': {method: 'PUT'}});

  var ResourceNote = ResourceWrapperService.WrapActions(RawResourceNote);

  _service.findOne = function (id, collectionId, projectId, resourceId, callback) {
    return ResourceNote.get({
      id: id,
      resourceId: resourceId,
      collectionId: collectionId,
      projectId: projectId
    }, function (resourceNote) {
      if (callback) callback(resourceNote);
    })
  };

  _service.findAll = function (projectId, collectionId, resourceId, callback) {
    return ResourceNote.query({
      projectId: projectId,
      collectionId: collectionId,
      resourceId: resourceId
    }, function (resourceNotes) {
      if (callback) callback(resourceNotes);
    });
  };

  _service.create = function (projectId, collectionId, resourceId, noteCategoryName, note) {
    return new ResourceNote({
      projectId: projectId,
      collectionId: collectionId,
      resourceId: resourceId,
      noteCategoryName: noteCategoryName,
      note: note
    });
  };

  _service.delete = function (note, callback, errorCallback) {
    note.$delete(function (response, deleteResponseHeaders) {
      if (callback) callback(response);
    }, function () {
      NotificationService.addError({
        title: 'Error deleting note',
        description: "That's embarrassing, please try again later",
        timeout: 5000
      });
      if (errorCallback) errorCallback();
    });
  };


  _service.save = function (newResourceNote, callback, errorCallback) {
    return newResourceNote.$save(function (resourceNote) {

      //_service.custodians[newCustodian.projectId].unshift(custodian);
      if (callback) callback(resourceNote);

    }, function (response) {
      if (errorCallback) errorCallback(response.data);
    });
  };

  return _service;

}]);
